import $api from "@/frontend/shared/api/axios";

export type TCompetitorData = {
  name: string;
  website: string;
  linkedIn: string;
};

export type TReturnedCompetitor = {
  id: number;
  name: string;
  website: string;
  linkedinUrl: string;
  headline: string;
  logoUrl: string;
};

export async function postAddCompetitor(data: TCompetitorData): Promise<TReturnedCompetitor> {
  const res = await $api.post(`/founder-revisions/add-competitor`, data);
  return res.data.data;
}
